import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { PatternMode, DetectionPattern } from '../../../types/vendor-types';

interface CreatePatternPayload {
  vendor: number;
  label?: string;
  pattern: string;
  pattern_mode?: PatternMode;
  case_sensitive?: boolean;
  priority?: number;
}

const useCreateVendorDetectionPattern = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreatePatternPayload) => (await glynt).vendor.createVendorDetectionPattern(data),
    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useCreateVendorDetectionPattern;
